import { useIsAuthenticated } from '@azure/msal-react';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../utils/SSO/authConfig";
import { useEffect } from 'react';
import Cookie from "universal-cookie";

export default function useAuthenticate() {
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts, inProgress } = useMsal();
  const cookie = new Cookie();

  const fetchTokenFromAZ = async () => {
    return await instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then((response: any) => {
        cookie.set("acc_token", response.accessToken,{
          expires:response.expiresOn
        });
        return response.accessToken;
      });
  }

  useEffect(() => {
    isAuthenticated && fetchTokenFromAZ();
  }, [isAuthenticated])
  const loginAZ = () => {
    instance.loginRedirect(loginRequest).catch((e: any) => {
      console.log(e, "....error.....");
    });
  }

  const getToken = async () => {
    if (!isAuthenticated) return '';
    let token = cookie.get("acc_token");
    if (token) return token;
    else {
      return await fetchTokenFromAZ();
    }
  }
  const logoutAZ = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/login",
    });
  }
  return {
    isAuthenticated: isAuthenticated,
    login: loginAZ,
    logout: logoutAZ,
    getToken: getToken,
    getTokenFromStorage: () => cookie.get("acc_token"),
    inProgress: inProgress !== 'none',
    accounts,
  }
}